import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Private_Routes } from '../constants';
interface props {
    children: JSX.Element[] | JSX.Element;
    redirect: string;
}

export const NotFoundRoutes = ({ children, redirect }: props) => {
    return (
        <Routes>
            {children}
            <Route path='*' element={<Navigate replace to={redirect} />} />
        </Routes>
    );
};

export const NotFoundPublicRoutes = ({ children, redirect }: props) => {
    const { pathname } = useLocation();

    return (
        <Routes>
            {children}
            {!pathname.includes('requests-management') ? (
                <Route path='*' element={<Navigate to={redirect} />} />
            ) : (
                <Route path='*' element={<Navigate to={redirect + pathname} />} />
            )}
        </Routes>
    );
};
